import { Modal } from "react-bootstrap";
import { useDataContext } from "../../../utils/DataContext";
import { useState } from "react";
import "../../../styles/org-buttons.css";
import { buttonText } from "../../../utils/buttonText";

function MntPage(props) {
  const { onHide } = props;
  const { setSelectedSource } = useDataContext();
  const [inputValue, setInputValue] = useState("");

  const handleConfirm = () => {
    setSelectedSource("goToMntPage");
    props.onMntPathChange(inputValue);
    onHide();
  };

  return (
    <div className="acquisition-upload-page">
      <div>
        <label htmlFor="input-field">Please Type Your Path</label>
      </div>
      <div>
        <input
          id="input-field"
          type="text"
          value={inputValue}
          onChange={(event) => setInputValue(event.target.value)}
        />
      </div>
      <Modal.Footer className="org-modal-footer">
        <button type="button" className="org-btn org-btn-primary" onClick={handleConfirm}>
          {buttonText("Confirm")}
        </button>
      </Modal.Footer>
    </div>
  );
}

export default MntPage;
